/**
 * Specifies smithchart animationComplete event name.
 *
 * @private
 */
export const animationComplete = 'animationComplete';
/**
 * Specifies smithchart legendRender event name.
 *
 * @private
 */
export const legendRender = 'legendRender';
/**
 * Specifies smithchart titleRender event name.
 *
 * @private
 */
export const titleRender = 'titleRender';
/**
 * Specifies smithchart subtitleRender event name.
 *
 * @private
 */
export const subtitleRender = 'subtitleRender';
/**
 * Specifies smithchart textRender event name.
 *
 * @private
 */
export const textRender = 'textRender';
/**
 * Specifies smithchart seriesRender event name.
 *
 * @private
 */
export const seriesRender = 'seriesRender';
/**
 * Specifies smithchart load event name.
 *
 * @private
 */
export const load = 'load';
/**
 * Specifies smithchart loaded event name.
 *
 * @private
 */
export const loaded = 'loaded';
/**
 * Specifies smithchart axisLabelRender event name.
 *
 * @private
 */
export const axisLabelRender = 'axisLabelRender';
